module.exports = __webpack_public_path__ + "static/img/12.61e0bc6.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/2/5/eng/12.png
// module id = +wdS
// module chunks = 0